<script>
    import {BForm} from 'bootstrap-vue/src/components/form/index';

    export default {
        extends: BForm,

        props: {
            novalidate: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>
